import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { EColumnKind } from "./types";
import { formatInteger, formatRatio } from "./lib/format";
/** One figure, large: a count grouped by the locale, a ratio as a percentage, "—" when undefined. */
export function MonitoringKpi(_a) {
    var label = _a.label, value = _a.value, kind = _a.kind;
    var i18n = useTranslation().i18n;
    var text = kind === EColumnKind.NUMBER
        ? formatRatio(value, i18n.language)
        : formatInteger(value, i18n.language);
    return (_jsxs(Box, { sx: { minWidth: 120, px: 1 }, children: [_jsx(Typography, { variant: "h5", component: "p", sx: { fontVariantNumeric: "tabular-nums" }, children: text }), _jsx(Typography, { variant: "body2", color: "text.secondary", children: label })] }));
}
